import moment from 'moment';

export const isNewPaycheck = (formValues, lastPaycheckDateValue) => {
  if (!lastPaycheckDateValue || !formValues) {
    return true;
  }

  const formValueYear = formValues.year?.value || moment().year();
  const formValueMonth = formValues.month?.value || moment().month() + 1;
  const formDate = new Date(formValueYear, formValueMonth - 1);
  const dataDate = new Date(lastPaycheckDateValue.year, lastPaycheckDateValue.month - 1);

  return formDate >= dataDate;
};